<top-banner variant="title" [title]="selectedSite?.name"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-site-tab-menu [site]="selectedSite"></app-site-tab-menu>
          </div>
          <div class="col-md-10">
            <div class="work-order-details-header">
              <div class="work-order-details-header-top">
                <card-section-header title="Work Order Details" icon="fas fa-list"></card-section-header>
                <div *ngIf="!hideBasicEditControls" class="button-link-wrapper d-flex justify-content-end work-order-actions">
                  <button type="button" class="btn btn-primary btn-link" (click)="onEditDescriptionClick()"> <span><i class="fas fa-edit"></i></span> Edit description</button>
                  <button *ngIf="workOrderStateService.allowChangeApprovalStatus(workOrderState)" type="button" class="btn btn-secondary btn-link" (click)="onChangeStatusClick()"> <span><i class="fas fa-edit"></i></span> Change status</button>
                  <button *ngIf="workOrderStateService.allowDeleteWorkOrder(workOrderState)" type="button" class="btn btn-danger btn-link" (click)="onDeleteWorkOrder()"><span><i class="fas fa-close"></i></span> Delete</button>
                </div>
              </div>
              <div class="title-and-badge-wrapper">
                <h4 class="work-order-subtitle">
                  Work Order:
                  <ng-container *ngIf="workOrder?.externalWorkOrderId; else internalWorkOrderTitle">
                    EXT{{ workOrder.externalWorkOrderId }} | <span class="work-order-title-wrk">WRK{{ workOrderId }}</span>
                  </ng-container>
                  <ng-template #internalWorkOrderTitle>
                    WRK{{ workOrderId }}
                  </ng-template>
                </h4>
                <work-order-state-badge *ngIf="workOrder" [workOrder]="workOrder"></work-order-state-badge>
              </div>
            </div>
            <div *ngIf="!workOrder" style="width: 100px; margin: 0 auto">
              <p-progressSpinner></p-progressSpinner>
            </div>
            <div *ngIf="workOrder" class="mb-2 animated fadeIn">
              <p>
                {{ workOrder.description }}
              </p>
              <action-bar
                    [siteId]="selectedSiteId"
                    [workOrder]="workOrder"
                    [openSessions]="openSessions"
                    [suspendedDetails]="suspendedDetails"
                    [surrenderedDetails]="surrenderedDetails"
                    [workOrderState]="workOrderState"
                    [allowWorkOrderScheduling]="allowWorkOrderScheduling"
                    [requiresToc]="requiresToc"
                    (refreshNeeded)="setupPage()"
                    [userSession]="userSession"
                    [leadWorkerSession]="leadWorkerSession"
                    [addSessionWorkers]="addSessionWorkers">
            </action-bar>
              <div class="sl-accordion work-order-accordion">

                <div class="widescreen-inline">

                  <sl-accordion-section title='Asset' class="work-order-asset-section">
                    <p>
                      <i *ngIf="!workOrder.asset.locked" class="fas fa-unlock color_green-shade1"></i>
                      <i *ngIf="workOrder.asset.locked" class="fas fa-lock color_red-shade1"></i>
                      &nbsp;
                      <a class="under-row" [routerLink]="['/' + routeRole, 'sites', selectedSiteId, 'assets', workOrder.asset.id ]">{{ workOrder.asset.name }}</a>
                    </p>
                    <p>
                      {{ workOrder.asset.description}}
                    </p>

                    <div class="sl-accordion-content-overflow-wrapper">
                      <p *ngIf="workOrder.asset.restrictions.length">
                        <ng-container *ngFor="let restriction of workOrder.asset.restrictions">
                          <p class="asset-restriction"><i class="fas fa-exclamation-triangle"></i>
                            {{ restriction.description }}</p>
                          </ng-container>
                      </p>
                      <p *ngIf="workOrder.asset.site.restrictions.length">
                        <ng-container *ngFor="let restriction of workOrder.asset.site.restrictions">
                          <p class="asset-restriction"><i class="fas fa-exclamation-triangle"></i>
                            {{ restriction.description }}</p>
                        </ng-container>
                      </p>
                    </div>
                    <p *ngFor="let category of workOrder.asset.assetCategories">
                      <span class="badge badge-pill badge-primary"
                        [ngStyle]="{ 'background-color': category.color }">{{category.name}}</span>
                    </p>
                  </sl-accordion-section>

                  <sl-accordion-section title='Minimum Work Party Size'>
                    <p>{{ workOrder.minimumPartySize }}</p>
                    <div *ngIf="!isControlAdmin" class="button-link-wrapper">
                      <button class="btn btn-primary btn-link" (click)="onEditMinPartyClick()">edit</button>
                    </div>
                  </sl-accordion-section>

                  <sl-accordion-section *ngIf="allowWorkOrderScheduling" title='Schedule'>
                    <schedule-display-section [workOrder]="workOrder" (refreshNeeded)="setupPage()"></schedule-display-section>
                  </sl-accordion-section>

                  <sl-accordion-section *ngIf="allowAssetScheduling && !exemptFromAssetScheduling" title='Exempt from scheduling'>
                    <p *ngIf="workOrder.exemptFromAssetScheduling">
                      <i class="fas fa-check-circle success"></i>
                      &nbsp;
                      This work order can be started at any time.
                    </p>
                    <p *ngIf="!workOrder.exemptFromAssetScheduling">
                      <i class="fas fa-times-circle danger"></i>
                      &nbsp;
                      This work order must be started within an availability window.
                    </p>
                    <div *ngIf="!isControlAdmin" class="button-link-wrapper">
                      <button type="button" class="btn btn-primary btn-link" (click)="changeExemptStatus()">change</button>
                    </div>
                  </sl-accordion-section>

                </div>

                <div class="widescreen-inline">
                  <sl-accordion-section title='Competencies'>

                    <div class="competencies-content">
                      <div class="mb-4">
                        <div class="competency-section-header">
                          <p><i class="fas fa-user"></i> Lead Worker</p>
                          <div *ngIf="!isControlAdmin && isCompetencyEditingOpenForState" class="button-link-wrapper">
                            <button type="button" class="btn btn-primary btn-link" (click)="onEditCompetencies('LEAD')"> <span><i class="fas fa-plus"></i></span> Add</button>
                          </div>
                        </div>
                        <div class="sl-accordion-content-overflow-wrapper">
                          <div class="competency-card-grid">
                            <competency-card
                                *ngFor="let competency of leadWorkerCompetencies"
                                [competency]="competency"
                                cardType="work-order-edit"
                                [workOrderStateAllowsDelete]="isCompetencyEditingOpenForState"
                                (delete)="onCompetencyDelete($event)">
                            </competency-card>
                          </div>
                        </div>
                      </div>

                      <div class="mt-5">
                        <div class="competency-section-header">
                          <p><i class="fas fa-users"></i> All Workers</p>
                          <div *ngIf="!isControlAdmin && isCompetencyEditingOpenForState" class="button-link-wrapper">
                            <button type="button" class="btn btn-primary btn-link" (click)="onEditCompetencies('ALL')"> <span><i class="fas fa-plus"></i></span> Add</button>
                          </div>
                        </div>
                        <div class="sl-accordion-content-overflow-wrapper">
                          <div class="competency-card-grid">
                            <competency-card
                                *ngFor="let competency of allWorkerCompetencies"
                                [competency]="competency"
                                cardType="work-order-edit"
                                [workOrderStateAllowsDelete]="isCompetencyEditingOpenForState"
                                (delete)="onCompetencyDelete($event)">
                            </competency-card>
                          </div>
                        </div>
                      </div>
                    </div>

                  </sl-accordion-section>
                </div>

                <div class="widescreen-inline">

                  <sl-accordion-section *ngIf="allowCompulsoryCheckOnSiteForm" title='Check-On Site Form'>
                    <p>{{ workOrder.checkOnSiteFormName }}</p>
                    <div *ngIf="!isControlAdmin" class="button-link-wrapper">
                      <button class="btn btn-primary btn-link" (click)="onEditSiteFormClick('Check-On')">edit</button>
                      <button *ngIf="allowCheckOnFormSubmit" class="btn btn-primary btn-link" (click)="showSiteFormEntryModal('checkOn')">submit response</button>
                    </div>
                  </sl-accordion-section>

                  <sl-accordion-section *ngIf="allowCompulsoryCheckOffSiteForm" title='Check-Off Site Form'>
                    <p>{{ workOrder.checkOffSiteFormName }}</p>
                    <div *ngIf="!isControlAdmin" class="button-link-wrapper">
                      <button class="btn btn-primary btn-link" (click)="onEditSiteFormClick('Check-Off')">edit</button>
                      <button *ngIf="allowCheckOffFormSubmit" class="btn btn-primary btn-link" (click)="showSiteFormEntryModal('checkOff')">submit response</button>
                    </div>
                  </sl-accordion-section>

                  <sl-accordion-section title='Documents / RAMS'>
                    <div class="sl-accordion-content-overflow-wrapper">
                      <div *ngFor="let file of workOrder.files" class="file-list-item">
                        <p>
                          {{ file.fileName | fileName }}
                        </p>
                        <div class="file-list-links">
                          <button type="button" class="btn btn-primary btn-link" (click)="openFile(file)">view</button>
                          <button *ngIf="!isControlAdmin" type="button" class="btn btn-danger btn-link" (click)="deleteFile(file)">delete</button>
                        </div>
                      </div>
                    </div>
                    <button *ngIf="!isControlAdmin" class="btn btn-primary btn-sm work-order-button" (click)="onAddDocumentsClicked()">Add Documents</button>
                  </sl-accordion-section>
                </div>

                <sl-accordion-section title='Completed Site Forms'>
                  <div class="sl-accordion-content-overflow-wrapper">
                    <p *ngIf="siteFormResponses.length === 0">No Site Forms Submitted</p>
                    <ng-container  *ngFor="let response of siteFormResponses">
                      <p>{{ response.form.name }}  <a class="under-row" [routerLink]="['/' + routeRole, 'site-forms', response.form.id,  'response', response.id ]" [queryParams]="{workOrderId: workOrder.id}">view</a></p>
                      <p class="comment-owner">{{ response.user.fullName }} - {{ response.createdDate | date: 'medium' }}<span *ngIf="response.submittedBy">&nbsp;(Submitted by {{ response.submittedBy }})</span></p>
                      <hr />
                    </ng-container>
                  </div>
                </sl-accordion-section>

                <sl-accordion-section *ngIf="showSessionsSection" title='Worker Sessions'>
                  <div class="sl-accordion-content-overflow-wrapper">
                    <div *ngFor="let session of allSessions" class='session-list-item'>
                      <div class='session-list-main'>
                        <div>
                          <date-range-friendly [start]="session.startTime" [end]="session.endTime"></date-range-friendly>
                        </div>
                        <div><b>{{ session.workerName }}</b></div>
                        <div>{{ session.matainenanceName }}</div>
                      </div>

                      <div class='session-list-notes'>
                        <div *ngIf="session.reason">Reason: {{ session.reason }}</div>
                        <div *ngIf="session.notes">Notes: {{ session.notes }}</div>
                      </div>
                    </div>
                  </div>
                </sl-accordion-section>

                <sl-accordion-section *ngIf="showSessionsSection" title='Photos'>
                  <p>{{ photoCount }} {{ photoCount === 1 ? 'photo' : 'photos' }} uploaded</p>
                  <button class="btn btn-primary btn-sm work-order-button" [disabled]="photoCount < 1" (click)="viewPhotos()">View Photos</button>
                </sl-accordion-section>

                <sl-accordion-section title='Comments'>
                  <div class="sl-accordion-content-overflow-wrapper">
                    <ng-container *ngFor="let comment of workOrder.workOrderComments">
                      <p>{{ comment.comment }}</p>
                      <p class="comment-owner">
                        <username-display [userName]="comment.createdBy"></username-display> - {{ comment.createdDate | date: 'medium' }}
                      </p>
                      <hr />
                    </ng-container>
                  </div>
                  <button class="btn btn-primary btn-sm work-order-button" (click)="addComment()">Add Comment</button>
                </sl-accordion-section>
                <sl-accordion-section title='Contacts'>
                  <button class="btn btn-primary btn-sm work-order-button" (click)="getContacts()">View Contacts</button>
                </sl-accordion-section>
              </div>
              <div class="card-footer"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Work Order Contacts" [(visible)]="showContacts" [dismissableMask]="true" modal="true">
  <p-table [value]="contacts" [autoLayout]="true">
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Phone</th>
        <th>Email</th>
        <th>Company</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-contact>
      <tr>
        <td>{{ contact.firstName }} {{ contact.lastName }} ({{contact.login }})</td>
        <td>{{ contact.phoneNumber }}</td>
        <td><a href="mailTo: {{ contact.email }}?subject=Work Order: WRK{{ workOrderId }} {{ workOrder.description }}">{{ contact.email }}</a></td>
        <td>{{ contact.maintenanceName }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr><td [attr.colspan]="4"> No Contacts found</td></tr>
    </ng-template>
  </p-table>
</p-dialog>
